import { render } from "./shutdownRecord.vue?vue&type=template&id=9d9fa1ca&scoped=true"
import script from "./shutdownRecord.vue?vue&type=script&lang=js"
export * from "./shutdownRecord.vue?vue&type=script&lang=js"

import "./shutdownRecord.vue?vue&type=style&index=0&id=9d9fa1ca&scoped=true&lang=css"
import "./shutdownRecord.vue?vue&type=style&index=1&id=9d9fa1ca&lang=css"
script.render = render
script.__scopeId = "data-v-9d9fa1ca"

export default script